import React from 'react';

const FilterButton = ({ onClick, hasActiveFilters }) => {
  return (
    <button 
      className={`filter-button ${hasActiveFilters ? 'has-filters' : ''}`}
      onClick={onClick}
      aria-label="Filtrera artiklar"
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M3 7H21M6 12H18M9 17H15" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default FilterButton;
